// @ts-nocheck
import React from 'react';
import { useI18n } from '../i18n/I18nContext';

const LanguageSelector = ({ compact = false, className = '' }) => {
  const { language, setLanguage } = useI18n();

  return (
    <label className={`inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white/95 px-3 py-2 text-xs font-semibold text-slate-600 shadow-sm backdrop-blur ${className}`}>
      {!compact && <span>Idioma</span>}
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        className="rounded-lg border-0 bg-slate-50 py-1 pl-2 pr-7 text-xs font-bold text-slate-900 focus:ring-2 focus:ring-emerald-500"
        aria-label="Idioma do backoffice"
      >
        <option value="PT">🇵🇹 PT</option>
        <option value="ES">🇪🇸 ES</option>
        <option value="EN">🇬🇧 EN</option>
      </select>
    </label>
  );
};

export default LanguageSelector;
